import { METHOD, requestSet, requestExportPost } from '@/utils/request'
import { API_PROXY_PREFIX } from "@/services/api";

// 获取供应商仓库列表
// export async function apiReceiptPlanFactoryWarehouse (params) {
//   return requestSet(`/plan/v3/receipt/common/factoryWarehouse/list`, METHOD.POST, params)
// }
// 获取仓库列表
export async function apiReceiptPlanWarehouse (params) {
  return requestSet(`/plan/v3/receipt/common/warehouse/list`, METHOD.POST, params)
}
// 收货计划 - 新增
export async function apiReceiptPlanAdd (params) {
  return requestSet(`/plan/v3/receipt/plan/add`, METHOD.POST, params)
}
// 收货计划 - 批量审核
export async function apiReceiptPlanAudit (params) {
  return requestSet(`/plan/v3/receipt/plan/audit`, METHOD.POST, params)
}
// 收货计划 - 触发自动计算收货计划
export async function apiReceiptPlanAutoCalculate (params) {
  return requestSet(`/plan/v3/receipt/plan/auto/calculate`, METHOD.POST, params)
}
// 收货计划 - 批量取消数量
export async function apiReceiptPlanCancelQty (params) {
  return requestSet(`/plan/v3/receipt/plan/batch/cancelQty`, METHOD.POST, params)
}
// 收货计划 - 批量复制已作废单据
export async function apiReceiptPlanCopyPlan (params) {
  return requestSet(`/plan/v3/receipt/plan/copyPlan`, METHOD.POST, params)
}
// 导出收货计划
export async function apiReceiptPlanExport (params, fileName) {
  return requestExportPost(`${API_PROXY_PREFIX}/plan/v3/receipt/plan/exportReceiptPlan`, params, fileName)
}
// 收货计划 - 批量增货审核
export async function apiReceiptPlanFactoryAddAudit (params) {
  return requestSet(`/plan/v3/receipt/plan/factoryAdd/audit`, METHOD.POST, params)
}
// 收货计划 - 批量增货库位占用
export async function apiReceiptPlanFactoryAddoCcupationLocation (params) {
  return requestSet(`/plan/v3/receipt/plan/factoryAdd/occupationLocation`, METHOD.POST, params)
}
// 收货计划 - 批量作废
export async function apiReceiptPlanInvalid (params) {
  return requestSet(`/plan/v3/receipt/plan/invalid`, METHOD.POST, params)
}
// 收货计划列表(不拆分list和count)
export async function apiReceiptPlanList (params) {
  return requestSet(`/plan/v3/receipt/plan/list`, METHOD.POST, params)
}
// 收货计划 - 批量库位占用
export async function apiReceiptPlanOccupationLocation (params) {
  return requestSet(`/plan/v3/receipt/plan/occupationLocation`, METHOD.POST, params)
}
// 收货计划 - 批量下推
export async function apiReceiptPlanPushDown (params) {
  return requestSet(`/plan/v3/receipt/plan/pushDown`, METHOD.POST, params)
}
// 收货计划 - 批量驳回
export async function apiReceiptPlanReject (params) {
  return requestSet(`/plan/v3/receipt/plan/reject`, METHOD.POST, params)
}
// 【新】导入修改收货计划-导入创建执行
export async function apiReceiptPlanImportAdd (params) {
  return requestSet(`/plan/v3/receipt/plan/save/import/add`, METHOD.POST, params)
}
// 【新】导入修改收货计划-导出异常数据
export async function apiReceiptPlanErrorExport (params) {
  return requestSet(`/plan/v3/receipt/plan/save/import/error/export`, METHOD.POST, params)
}
// 【新】导入修改收货计划-读取导入文件
export async function apiReceiptPlanImportRead (params) {
  return requestSet(`/plan/v3/receipt/plan/save/import/read`, METHOD.POST, params)
}
// 收货计划 - 批量提交
export async function apiReceiptPlanSubmit (params) {
  return requestSet(`/plan/v3/receipt/plan/submit`, METHOD.POST, params)
}
// 欠货列表-五金箱库存
export async function apiHwReceiptPlanUnderShipmentGetList (params) {
  return requestSet(`/plan/v3/receipt/plan/underShipment/inventory/getList`, METHOD.POST, params)
}
// 欠货列表总数-五金箱库存
export async function apiHwReceiptPlanUnderShipmentGetTotal (params) {
  return requestSet(`/plan/v3/receipt/plan/underShipment/inventory/getTotal`, METHOD.POST, params)
}
// 欠货列表 - 五金箱库存合计
export async function apiHwReceiptPlanUnderShipmentListSum (params) {
  return requestSet(`/plan//v3/receipt/plan/underShipmentListSum/inventory`, METHOD.POST, params)
}
// 欠货列表（优化方案）
export async function apiReceiptPlanUnderShipmentGetList (params) {
  return requestSet(`/plan/v3/receipt/plan/underShipment/getList`, METHOD.POST, params)
}
// 欠货列表总数（优化方案）
export async function apiReceiptPlanUnderShipmentGetTotal (params) {
  return requestSet(`/plan/v3/receipt/plan/underShipment/getTotal`, METHOD.POST, params)
}
// 收货计划 - 批量修改收货计划
export async function apiReceiptPlanUpdateBatch (params) {
  return requestSet(`/plan//v3/receipt/plan/updateBatch`, METHOD.POST, params)
}

// 收货计划 - 库位占用调整
// export async function apiReceiptPlanAdjustLocationOccupancy (billNo, params) {
//   return requestSet(`/plan/v3/receipt/plan/${billNo}/adjustLocationOccupancy`, METHOD.POST, params)
// }
// 收货计划 - 编辑保存[单条]
export async function apiReceiptPlanSave (billNo, params) {
  return requestSet(`/plan/v3/receipt/plan/${billNo}/save`, METHOD.POST, params)
}

// 收货计划列表 - 合计
export async function apiReceiptPlanSum (params) {
  return requestSet(`/plan/v3/receipt/plan/sum`, METHOD.POST, params)
}
// 欠货列表 - 合计
export async function apiReceiptPlanUnderShipmentListSum (params) {
  return requestSet(`/plan//v3/receipt/plan/underShipmentListSum`, METHOD.POST, params)
}
// 获取供应商基础数据
export async function apiGetsupplier (params) {
  return requestSet(`/plan/v3/receipt/common/supplier/get`, METHOD.GET, params)
}
// 获取调度组成员列表
export async function apiGetDispatchList (params) {
  return requestSet(`/plan/v3/receipt/common/planTeam/dispatch/list`, METHOD.POST, params)
}

// 获取拆分收货计划行-获取拆分前信息
export async function apiGetPlanInfo (params) {
  return requestSet(`/plan/v3/receipt/plan/split/plan/info/get`, METHOD.GET, params)
}

// 获取拆分收货计划行-获取拆分前信息
export async function apiSaveSplitData (params) {
  return requestSet(`/plan/v3/receipt/plan/split/plan/info/save`, METHOD.POST, params)
}
